import { render, staticRenderFns } from "./ModuleCreation.vue?vue&type=template&id=7a8b2233"
import script from "./ModuleCreation.vue?vue&type=script&lang=js"
export * from "./ModuleCreation.vue?vue&type=script&lang=js"
import style0 from "./ModuleCreation.vue?vue&type=style&index=0&id=7a8b2233&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports